export default __webpack_public_path__ + "media/src/assets/images/sidebar_collpase-44141288dec90ae3c6791b4509d3ce99.svg";